
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-01-12-supabase-todo-app-row-level",
      function () {
        return require("private-next-pages/blogs/2025-01-12-supabase-todo-app-row-level/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-01-12-supabase-todo-app-row-level"])
      });
    }
  